import Vue from 'vue'
import axios from 'axios'
import EventBus from '@/store/EventBus'
import { setActingCommittee } from '@/services/actingCommittee'
import { ACTING_COMMITTEE_HEADER, ACTING_COMMITTEE_STORAGE_KEY } from '@/constants/actingCommittee'

const http = axios.create()

const ACTION_GATE_STORAGE_KEY = 'actionGateToken'

http.interceptors.request.use((config) => {
  config.baseURL = Vue.prototype.$api
  const token = localStorage.getItem('bearer')
  if (token) config.headers.Authorization = `Bearer ${token}`

  const acting = JSON.parse(localStorage.getItem(ACTING_COMMITTEE_STORAGE_KEY) || 'null')
  if (acting && acting.id) config.headers[ACTING_COMMITTEE_HEADER] = acting.id

  const gate = JSON.parse(localStorage.getItem(ACTION_GATE_STORAGE_KEY) || 'null')
  if (gate && gate.expiresAt > Date.now()) config.headers['X-Action-Gate-Token'] = gate.token

  return config
})

const TOKEN_CODES = ['token_expired', 'token_invalid', 'token_error']

function handleResponseError(error) {
  const data = error.response != null ? error.response.data : null
  const code = data != null ? data.code : null

  if (TOKEN_CODES.includes(code)) {
    localStorage.removeItem('bearer')
    window.location.href = '/login'
    return Promise.reject(error)
  }

  if (code === 'acting_committee_invalid') {
    setActingCommittee(null)
    window.location.href = '/'
    return Promise.reject(error)
  }

  if (code === 'committee_not_financial' && !window.location.pathname.startsWith('/committees/affiliation')) {
    window.location.href = '/committees/affiliation'
    return Promise.reject(error)
  }

  if (code !== 'validation_error' && !error.config.silent) {
    const message = data != null && data.message != null
      ? data.message
      : 'A server error occurred. Please try again later.'
    EventBus.$emit('http-error', message)
  }

  return Promise.reject(error)
}

http.interceptors.response.use(
  (response) => {
    const data = response.data
    if (response.config.silent && !response.config.localSuccess && data.message != null) {
      EventBus.$emit('show-success', data.message)
    }
    return response
  },
  (error) => {
    const isBlobError = error.response != null
      && error.response.data instanceof Blob
      && error.response.data.type === 'application/json'

    if (isBlobError) {
      return error.response.data.text().then((text) => {
        try {
          error.response.data = JSON.parse(text)
        } catch (_) {
          // leave error.response.data as-is if it isn't valid JSON
        }
        return handleResponseError(error)
      })
    }

    return handleResponseError(error)
  }
)

export default http



// WEBPACK FOOTER //
// ./src/services/api/http.js